var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgA3FloorLampOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.94 20.38h-4v-6h4v6zm13.22 2.38l-2.83-2.83-4.24 4.24L48.91 27l4.25-4.24zm-23.24 1.41l-4.24-4.24-2.83 2.83L27.09 27l2.83-2.83zM69 7v62H7V7h62zm-4 4H11v54h25V50H21l8.68-19h16.6L55 50H40v15h25V11z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/A3_Floor_lamp_on.7f4d3529.svg";
export { SvgA3FloorLampOn as ReactComponent };